import {
  Outlet,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import Dashboard from "./Containers/DashBoardView";
import RedirectPage from "./components/RedirectPage";
import Donation from "./Containers/DonationView";
import Login from "./pages/Login";
import Page404 from "./pages/Page404";
import CenteredTabs from "./Containers/OnBoarding";
import Register from "./pages/Register";
import VerifyEmail from "./sections/auth/VerifyEmail";
import SetNewPassword from "./sections/auth/SetNewPassword";
import { RegistrationStatus, UserType } from "./common/enum";
import VerifyAccount from "./Containers/VerifyAccount";
import AdminView from "./Containers/AdminView";
import AddBranch from "./components/AddBranch/AddBranch";
import RegistrationSuccess from "./Containers/RegistrationSuccess";
import { useEffect } from "react";
import { saveEntityData, saveUserData } from "./redux/features/authSlice";
import EventosRecolhidos from "./Containers/DonationView/EventosRecolhidos";
import { setEntityProfileSelect } from "./Containers/DashBoardView/slice";
import VerifyDocuments from "./sections/auth/VerifyEmail/VerifyDocuments";
import { loadProfileFromIndexedDB, removeFromIndexedDB } from "./storage/profileStorage";
export default function Router() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
var entityProfile;
var userData;
var entityProfileSelect;
  const isExist = [
    "/verify-email",
    "/verify-account",
    "/reset-password",
    "/set-password",
    "/verify-documents"
  ];
  // useEffect(() => {
  //   loadProfileFromIndexedDB((data) => {
  //     if (!data) {
  //       // tratamento para erro, dado nulo ou vazio
  //       return;
  //     }
  //     const { profile, user, entityProfile2} = data;
  //     // continue o código normalmente
  
  //       if (profile) {
  //         entityProfile = profile;
  //         // console.log("Perfil recuperado:", profile);
  //       } else {
  //         // console.log("Nenhum perfil encontrado.");
  //       }
  //       if(user){
  //         userData = user;
  //       }else{
  //         //  console.log("Nenhum perfil encontrado.");
  //       }

  //        if(entityProfile2){
  //         entityProfileSelect = entityProfile2;
  //       }else{
          
  //         //  console.log("Nenhum perfil encontrado.");
  //       }
  //     });
  //   // const userData = JSON.parse(localStorage.getItem("userData"));
  //   // const entityProfile = JSON.parse(localStorage.getItem("entityProfile"));

  //   if (userData) {
  //     dispatch(saveUserData(userData));
  //   }
  //   if (entityProfile) {
  //     dispatch(saveEntityData(entityProfile));
  //   }
 
   
  //   if (
  //     userData &&
  //     userData.token &&
  //     userData.token != "" &&
  //     entityProfile &&
  //     entityProfile.userType &&
  //     entityProfile.userType.toLowerCase() === "entity"
  //   ) {
  //     navigate("/dashboard", { replace: true });
  //   } else if (
  //     userData &&
  //     userData.token &&
  //     userData.token != "" &&
  //     entityProfile &&
  //     entityProfile.userType &&
  //     entityProfile.userType.toLowerCase() === "gpp_admin"
  //   ) {
  //     navigate("/admin", { replace: true });
  //   } else if (!isExist.includes(location.pathname)) {
  //     localStorage.removeItem("userData");
  //     localStorage.removeItem("entityProfile");
  //     navigate("/", { replace: true });
  //   }
  // }, []);
useEffect(() => {
  const params = new URLSearchParams(location.search);
     const id = params.get("collectionToken");

    // if (!id) {
    //   navigate("/", { replace: true });
    //   return;
    // }
    let tokenValue = null;
      for (const [key, value] of params.entries()) {
        if (key.toLowerCase().includes("token")) {
          tokenValue = value;
          break;
        }
      }

      // if (!tokenValue) {
      //   navigate("/", { replace: true });
      //   return;
      // }

  loadProfileFromIndexedDB((data) => {
    if (!data) {
      // Dados nulos: redirecionar para login
      removeFromIndexedDB("profiles", "entityProfile");
      removeFromIndexedDB("userData", "userData");
      removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
      // localStorage.removeItem("entityProfile");
      navigate("/", { replace: true });
      return;
    }

    var { profile, user, entityProfile2 } = data;

    if (user) {
      user = JSON.parse(user)
      dispatch(saveUserData(user));
    }
    if (profile) {
      profile = JSON.parse(profile)
      dispatch(saveEntityData(profile));
    }
    const entityProfileSelect = JSON.parse(localStorage.getItem("entityProfileSelect"))
    
    if(entityProfile2){
      entityProfile2 = entityProfile2
    }
    if (
      profile &&
      profile.entity?.entityType === "DONOR_DISTRIBUTOR"
    ) {
      // dispatch(setEntityProfileSelect(entityProfile2));
       dispatch(setEntityProfileSelect(entityProfileSelect));
    }

    // Lógica de navegação
    if (
      user &&
      user.token &&
      user.token !== "" &&
      profile &&
      profile.userType?.toLowerCase() === "entity"
    ) {
      navigate("/dashboard", { replace: true });
    } else if (
      user &&
      user.token &&
      user.token !== "" &&
      profile &&
      profile.userType?.toLowerCase() === "gpp_admin"
    ) {
      navigate("/admin", { replace: true });
    } else if (!isExist.includes(location.pathname)) {
      // localStorage.removeItem("userData");
      localStorage.removeItem("entityProfileSelect");
      removeFromIndexedDB("profiles", "entityProfile");
      removeFromIndexedDB("userData", "userData");
      removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
      navigate("/", { replace: true });
    }

     if (id) {
     navigate(`/dashboard/agenda?collectionToken=${id}`, { replace: true });
    }
  });
}, []);
  return (
    <Routes>
      <Route path="/" element={<LogoOnlyLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Page404 />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/verify-documents" element={<VerifyDocuments />} />
        <Route path="/verify-account" element={<VerifyAccount />} />
        <Route path="/reset-password" element={<SetNewPassword />} />
        <Route path="/set-password" element={<SetNewPassword />} />
        <Route path="/registration-success" element={<RegistrationSuccess />} />
        <Route element={<SecureRoutes />}>
          <Route element={<UserStatusRoutes status={"active"} />}>
            <Route path="/dashboard" element={<Dashboard />}>
              <Route path="donations" element={<Dashboard />} />
              <Route path="donations/my-donations" element={<Dashboard />} />
              <Route path="donations/history" element={<Dashboard />} />
              <Route path="agenda" element={<Dashboard />} />
              <Route path="profile" element={<Dashboard />} />
              <Route path="manage-branches" element={<Dashboard />} />
              <Route path="manage-managers" element={<Dashboard />} />
              <Route path="settings" element={<Dashboard />} />
            </Route>
            <Route path="/add-branch" element={<AddBranch />} />
            <Route path="/create-donation" element={<Donation />} />
            <Route path="/eventos-recolhidos" element={<EventosRecolhidos />} />
            <Route path="/redirect" element={<RedirectPage />} />
          </Route>
          <Route element={<UserStatusRoutes status={"activeAdmin"} />}>
            <Route path="/admin" element={<AdminView />} />
          </Route>
          {/* <Route path='/dashboard/profile' element={<Dashboard />} /> */}

          {/* <Route path='/myProfile' element={<UserProfile />} /> */}
          <Route element={<UserStatusRoutes status={"registering"} />}>
            <Route path="/multistep" element={<CenteredTabs />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

const SecureRoutes = () => {
  const { user = {} } = useSelector((state) => state.auth);
  // show unauthorized screen if no user is found in redux store
  if (
    user === null ||
    Object.keys(user).length === 0 ||
    user.status === undefined
  ) {
    return <Navigate to="/" replace />;
  }

  // returns child route elements
  return <Outlet />;
};

const UserStatusRoutes = ({ status }) => {
  const { user = {}, profile = {} } = useSelector((state) => state.auth);
  // show unauthorized screen if no user is found in redux store
  if (
    Object.keys(user).length > 0 &&
    (user.status === RegistrationStatus.active ||
      user.status === RegistrationStatus.inActive ||
      user.status === RegistrationStatus.inAtivo ||
      user.status === RegistrationStatus.revoked) &&
    status === "active"
  ) {
    return <Outlet />;
  } else if (
    Object.keys(user).length > 0 &&
    user.status === RegistrationStatus.registering &&
    status === "registering"
  ) {
    return <Outlet />;
  } else if (
    Object.keys(user).length > 0 &&
    user.status === RegistrationStatus.active &&
    status === "activeAdmin" &&
    profile.userType === UserType.gppAdmin
  ) {
    return <Outlet />;
  } else {
    return <Navigate to="/" replace />;
  }
};
